<template>
  <section class="mc-rec-section">
    <h2 class="mc-rec-section__title">Insights adicionais</h2>
    <p class="mc-rec-section__desc">Sinais para marketing e gestão.</p>
    <b-row>
      <b-col md="6" lg="3" class="mb-3" v-for="b in blocos" :key="b.titulo">
        <div class="mc-rec-insight">
          <div class="mc-rec-insight__title">{{ b.titulo }}</div>
          <div class="mc-rec-insight__value">{{ b.valor }}</div>
          <div v-if="b.sub" class="small text-muted mt-1">{{ b.sub }}</div>
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

export default {
  name: 'RecommendationInsights',
  components: { BRow, BCol },
  props: {
    blocos: { type: Array, default: () => [] },
  },
}
</script>
